import { Add, Close, Edit, ExpandMore, MoreVert, Phone } from "@mui/icons-material";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Collapse,
  Dialog,
  Divider,
  IconButton,
  List,
  ListItemButton,
  MenuItem,
  Menu,
  Stack,
  Typography,
  Zoom,
} from "@mui/material";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import Allocation from "./Allocation";
import { BaseHrmUrl } from "../../Intro/Constants";
import axios from "axios";

function People() {
  const [details, setDetails] = useState(null);
  const [people, setPeople] = useState(null);

  //fetch people

  useEffect(() => {
    async function loadData() {
      try {
        const response = await axios.get(`${BaseHrmUrl}/contacts/`);
        if (response.status === 200) {
          setPeople(response.data);
        }
         else {
          alert("Failed! Try again.");
        }
      } catch (error) {
        alert("Error fetching contacts, No internet?");
      }
    };
    loadData();},
     []);
  //handling details
  const handleDetails = (person) => {
    setDetails(<Details person={person} setDetails={setDetails} />);
  };

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
        <Typography variant="h6">People</Typography>
        <Divider variant="middle" />
        <Box display={"flex"} columnGap={2}>
          <Stack
            display={"flex"}
            justifyContent={"start"}
            width={"35%"}
            style={{ maxHeight: 500, overflow: "auto" }}
          >
            <List>
              {people ? (
                people.map((person) => {
                  return (
                    <Zoom
                      in={true}
                      style={{ transitionDelay: "200ms" }}
                      key={person.id}
                    >
                      <Card elevation={2} sx={{ width: "100%", my: 1 }}>
                        <CardActionArea onClick={() => handleDetails(person)}>
                          <CardContent>
                            <Box
                              display={"flex"}
                              alignItems={"center"}
                              columnGap={2}
                            >
                              <Avatar>{person.user.first_name[0]}</Avatar>
                              <Typography variant="body1">
                                {person.user.first_name} {person.user.last_name}
                              </Typography>
                            </Box>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </Zoom>
                  );
                })
              ) : (
                <Typography variant="body1">No contacts available</Typography>
              )}
            </List>
          </Stack>
          <Stack my={1} width={"60%"}>
            {details}
          </Stack>
        </Box>
      </Stack>
    </Zoom>
  );
}

export default People;

function Details(props) {
  const { person, setDetails } = props;
  const [title, setTitle] = useState("Show More");
  const [collapse, setCollapse] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState(null);
  const [anchorEl, setAnchoeEl] = useState(null);
  const accountMenu = Boolean(anchorEl);

  const handleAllocate = () => {
    setDetails(<Allocator person={person} />);
  };
  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack rowGap={1}>
        <Card>
          <CardActions sx={{ justifyContent: "end" }}>
            <Box>
              <IconButton onClick={(e) => setAnchoeEl(e.target)}>
              <MoreVert />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              id="user-account-menu"
              open={accountMenu}
              onClose={() => setAnchoeEl(null)}
              onClick={() => setAnchoeEl(null)}
              slotProps={{
                paper: {
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem>Deactivate</MenuItem>
              <MenuItem>Message</MenuItem>
            </Menu>
            </Box>
            
          </CardActions>
          <CardContent>
            <Box display={"flex"} justifyContent={"center"}>
              <Badge
                badgeContent={
                  <IconButton sx={{ border: "1px solid white" }}>
                    <Edit color="info" />
                  </IconButton>
                }
                overlap="circular"
              >
                <Avatar
                  src="https://cdn.pixabay.com/photo/2017/05/22/07/20/woman-2333326_640.jpg"
                  sx={{ width: 200, height: 200 }}
                >
                  IMG
                </Avatar>
              </Badge>
            </Box>
            <Box display={"flex"} justifyContent={"end"} columnGap={2}>
              <Phone />
              <Typography variant="body1">{person.primary_phone}</Typography>
              <Typography variant="body1">
                {person.user.first_name} {person.user.last_name}
              </Typography>
            </Box>
          </CardContent>
        </Card>
        <Card>
          <CardActionArea
            onClick={() => {
              setCollapse(!collapse);
              collapse ? setTitle("Show More") : setTitle("Show Less");
            }}
          >
            <Box display={"flex"} justifyContent={"center"} columnGap={2}>
              <Typography variant="body1">{title}</Typography>
              <ExpandMore />
            </Box>
          </CardActionArea>
          <CardContent>
            <Collapse in={collapse} timeout="auto" unmountOnExit>
              <Stack rowGap={2}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  Department :{" "}
                  {person.section
                    ? person.section.department.department
                    : "None"}
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  Section : {person.section ? person.section.section : "None"}
                </Typography>
                {person.section ? (
                  <Box display={"flex"} justifyContent={"space-evenly"}>
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{ borderRadius: 4 }}
                    >
                      edit contact
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{ borderRadius: 4 }}
                      onClick={() => {
                        setOpenDialog(true);
                        setDialogContent(
                          <EditUserDeductions
                            person={person}
                            setOpen={setOpenDialog}
                          />
                        );
                      }}
                    >
                      edit deductions
                    </Button>
                  </Box>
                ) : (
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={handleAllocate}
                  >
                    Allocate
                  </Button>
                )}
              </Stack>
            </Collapse>
          </CardContent>
          <Dialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            fullWidth={true}
            maxWidth="sm"
          >
            {dialogContent}
          </Dialog>
        </Card>
      </Stack>
    </Zoom>
  );
}

function Allocator(props) {
  const { person } = props;
  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack rowGap={1}>
        <CardContent>
          <Typography variant="h6" sx={{ textDecoration: "bold" }}>
            General
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ textDecoration: "bold" }}>
                {person ? person.user.username : null}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" sx={{ textDecoration: "bold" }}>
                {person ? person.user.first_name : null}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" sx={{ textDecoration: "bold" }}>
                {person ? person.user.last_name : null}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" sx={{ textDecoration: "bold" }}>
                {person ? person.primary_phone : null}
              </Typography>
            </Grid>
          </Grid>
          <Allocation person={person} />
        </CardContent>
      </Stack>
    </Zoom>
  );
}

function EditUserDeductions(props) {
  const defaults = [
    { id: 1, deduction_name: "NHIF", rate: 200, type: "amount" },
  ];

  const other = [
    { id: 1, deduction_name: "Housing", rate: 2, type: "percent" },
  ];
  const { person, setOpen } = props;

  const handleSubscribe = (deduction) => {};
  const handleUnsubscribe = (deduction) => {};

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack rowGap={1}>
        <CardContent>
          <Box display={"flex"}>
            <Typography variant="h6" alignSelf={"center"}>
              {person.user.first_name} {person.user.last_name}
            </Typography>
            <IconButton onClick={() => setOpen(false)} sx={{ ml: "auto" }}>
              <Close color="error" />
            </IconButton>
          </Box>
          <Divider />
          <Box display={"flex"} columnGap={1}>
            <Card elevation={2} sx={{ width: "49%" }}>
              <CardContent>
                <Typography fontWeight={"bold"}>Default Deductions</Typography>
                <Divider />
                {defaults ? (
                  defaults.map((def) => {
                    return (
                      <ListItemButton>
                        <Typography variant="body1">
                          {" "}
                          {def.deduction_name}{" "}
                          {def.type === "amount" ? "Ksh" : null}
                          {def.rate}
                          {def.type === "percent" ? "%" : null}
                        </Typography>
                      </ListItemButton>
                    );
                  })
                ) : (
                  <Typography>No deductions</Typography>
                )}
              </CardContent>
            </Card>
            <Card elevation={2} sx={{ width: "49%" }}>
              <CardContent>
                <Typography fontWeight={"bold"}>Other Deductions</Typography>

                <Divider />
                {other ? (
                  other.map((other_ded) => {
                    return (
                      <CardContent key={other_ded.id}>
                        <Box display={"flex"} alignItems={"center"}>
                          <Typography variant="body1">
                            {other_ded.deduction_name}{" "}
                            {other_ded.type === "amount" ? "Ksh" : null}
                            {other_ded.rate}
                            {other_ded.type === "percent" ? "%" : null}
                          </Typography>
                          {other_ded.subscribed ? (
                            <Button
                              onClick={handleSubscribe}
                              variant="outlined"
                              size="small"
                              sx={{ borderRadius: 4, ml: "auto" }}
                            >
                              unsubscribe
                            </Button>
                          ) : (
                            <Button
                              onClick={handleUnsubscribe}
                              variant="outlined"
                              sx={{ borderRadius: 4, ml: "auto" }}
                              size="small"
                            >
                              unsubscribe
                            </Button>
                          )}
                        </Box>
                      </CardContent>
                    );
                  })
                ) : (
                  <Typography>No subscribed deductions</Typography>
                )}
              </CardContent>
            </Card>
          </Box>
        </CardContent>
      </Stack>
    </Zoom>
  );
}
